import isEmpty from 'lodash/isEmpty';

import { TFunction } from '@lyearn/i18n';
import { Fields, FieldType } from '@/components/Form';
import { PropertiesToDuplicateEnum } from '@/types/schema';

import {
  getProjectPropertiesToDuplicateOptions,
  getTaskPropertiesToDuplicateOptions,
  ProjectPropertiesToDuplicateEnum,
} from '../../utils';
import PropertiesToDuplicateSelector from '../PropertiesToDuplicateSelector';

export type ProjectDuplicationFormPropertiesType = {
  projectPropertiesToDuplicate: ProjectPropertiesToDuplicateEnum[];
  actionItemPropertiesToDuplicate: PropertiesToDuplicateEnum[];
};

export type DuplicateProjectEditorFormValues = {
  title: string;
  duplicateFromId: string;
  properties: ProjectDuplicationFormPropertiesType;
};

export const getInitialValues = ({
  t,
  duplicateFromId,
  title,
}: {
  t: TFunction;
  duplicateFromId?: string;
  title?: string;
}): DuplicateProjectEditorFormValues => {
  return {
    duplicateFromId: duplicateFromId || '',
    title: title ? title + t('Task:DuplicationProperties.Copy') : t('Task:DuplicateProject.Title'),
    properties: {
      projectPropertiesToDuplicate: getProjectPropertiesToDuplicateOptions(t).map(
        (option) => option.value,
      ),
      actionItemPropertiesToDuplicate: getTaskPropertiesToDuplicateOptions(t).map(
        (option) => option.value,
      ),
    },
  };
};

export const getFormFields = (t: TFunction): Fields<DuplicateProjectEditorFormValues> => {
  return {
    title: {
      name: 'title',
      label: t('Task:DuplicateProject.NewProjectName'),
      type: FieldType.Text,
      size: 'large',
      required: true,
    },
    properties: {
      name: 'properties',
      required: true,
      type: FieldType.Custom,
      label: t('Task:DuplicationProperties.PropertiesToDuplicateLabel'),
      Component: ({ value, onChange }) => {
        return <PropertiesToDuplicateSelector value={value} onChange={onChange} />;
      },
    },
  };
};

export const FORM_LAYOUT = ['title', 'properties'];

export const validateForm = (t: TFunction) => (values: any) => {
  const errors: any = {};

  if (isEmpty(values.title)) {
    errors.title = t('Task:DuplicateProject.ProjectNameCannotBeEmpty');
  }

  return errors;
};
